<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>Геокодирование</T>
    </Teleport>  

    <Teleport to="#settings-group-actions">
      <!-- <v-tabs v-model="tab">
        <v-tab><T>Провайдер геоданных</T></v-tab>
        <v-tab><T>Зоны доставки</T></v-tab>
      </v-tabs> -->
      <v-btn
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>


    <GeocoderParams :config="$store.getters.local_refs.geocoding" :loading="loading" ref="form"/>

    <!-- <v-tabs-items v-model="tab">
      <v-tab-item>
      </v-tab-item>
      <v-tab-item>
        <v-btn @click="setCenter">setCenter</v-btn>

        <LMap 
          style="height: 600px; width: 100%"
          :zoom="13"
          :center="center"
          
        >
          <LTileLayer 
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
            :attribution="attribution"
          />
        </LMap>
      </v-tab-item>
    </v-tabs-items> -->


    
    

  </div>
</template>

<script>
import Teleport from 'vue2-teleport'

// import 'leaflet/dist/leaflet.css'

import GeocoderParams from '../../components/settings/geocoding'

// import L from 'leaflet'
// import {latLng} from 'leaflet'
// import {LMap, LTileLayer} from 'vue2-leaflet'

export default {
  data: () => ({
    loading: false
    // tab: 0,
    // zoom: 13,
    // center: latLng(47.41322, -1.219482),
    // attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let new_config = {geocoding: this.$refs.form.submit()}
        
        await this.$store.dispatch('updateLocalRefs', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
    // setCenter(){
    //   this.center = latLng(54.991494, 82.912764);
    // }
  },
  components: {
    Teleport,
    GeocoderParams,
    // LMap,
    
    // LTileLayer
  }
}
</script>

<style>
.leaflet-attribution-flag {
  display: none !important;
}
</style>